import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import RadioButton from 'LuxKit/Radio/RadioButton'
import clsx from 'clsx'
import Colour from 'components/utils/Colour'
import noop from 'lib/function/noop'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

const IndentableListItem = styled(ClickableListItem)`
  &.indented {
    padding-left: ${rem(52)};
  }
`

interface Props {
  airport: App.AirportLocation
  onClick?: (airport: App.AirportLocation) => void
  selected?: boolean
  indented?: boolean
  withRadioButton?: boolean
}

function OfferAirportSelectOption(props: Props) {
  const { airport, onClick = noop, selected, indented = false, withRadioButton = false, ...rest } = props
  const onAirportSelect = useCallback(() => {
    onClick(airport)
  }, [airport, onClick])

  let title: React.ReactNode = <>{airport.airportName} <Colour value="neutral-three">{airport.airportCode}</Colour></>
  if (airport.isMultiAirport) {
    const splitName = (/^(.+) all airports$/i).exec(airport.airportName)
    const cityName = splitName?.[1] ?? airport.cityDesc
    if (cityName) {
      title = <FormattedMessage
        id="B7nJUHuHbh"
        defaultMessage="{cityName} <muted>All airports</muted>"
        description="Airport option title showing city name with all airports indicator"
        values={{
          cityName,
          muted: (chunks) => <Colour value="neutral-three">{chunks}</Colour>,
        }}
      />
    } else {
      title = airport.airportName
    }
  }

  const subtitle = [airport.cityDesc, airport.country].filter(str => str).join(', ') || undefined

  return <IndentableListItem
    {...rest}
    className={clsx({ indented })}
    size="large"
    startIcon={withRadioButton ? <RadioButton checked={selected} /> : <LinePlaneDepartureIcon />}
    title={title}
    subtitle={<Colour value="neutral-three">{subtitle}</Colour>}
    onClick={onAirportSelect}
    selected={selected}
  />
}

export default OfferAirportSelectOption
